module.exports = __webpack_public_path__ + "static/media/avtar.5fd88976.svg";